import { useRmaStore } from '@/entities/rma';
import { SEARCH_BY_LIST } from '../../../config/waitingToReturnTab';

/**
 * State of the search row on the RMA waiting-to-return tab. Reads waitingToReturnFilter from the RMA store, defaults searchValue to an empty string and searchByValue to the first SEARCH_BY_LIST entry, and exposes a change handler that patches the search term alone or stores a new search field while clearing the term.
 *
 * @returns The current search term, the selected search field and the change handler.
 */
const useWaitingToReturnSearch = () => {
  /**
   * The persisted waiting-to-return search filter held in the RMA store. Selected off useRmaStore as waitingToReturnFilter and destructured for searchValue and searchByValue.
   *
   * @returns The stored waiting-to-return filter object.
   */
  const waitingToReturnFilter = useRmaStore((s) => s.waitingToReturnFilter);
  const { searchValue = '', searchByValue = SEARCH_BY_LIST[0].value } = waitingToReturnFilter;
  /**
   * The RMA store action that patches the waiting-to-return filter. Selected off useRmaStore as updateWaitingToReturnFilter.
   *
   * @returns The store updater for the waiting-to-return filter.
   */
  const setStateRedux = useRmaStore((s) => s.updateWaitingToReturnFilter);

  /**
   * Writes a change from the RMA waiting-to-return search row back into the store filter. Patches searchValue alone when that field changed, otherwise stores the new searchByValue and resets searchValue to an empty string.
   *
   * @param name - Which search field changed.
   * @param value - New value of the changed field.
   * @returns Nothing.
   */
  const onChangeSearchComponent = (name: any, value: any) => {
    if (name === 'searchValue') {
      setStateRedux({ searchValue: value });
    } else {
      setStateRedux({
        searchByValue: value,
        searchValue: '',
      });
    }
  };

  return {
    searchValue,
    searchByValue,
    onChangeSearchComponent,
  };
};

export { useWaitingToReturnSearch };
